import { apiClient } from "@/shared/api/client"
import type { PondResponse, PondCreateRequest, PondUpdateRequest } from "@/shared/types/api"

export const pondsApi = {
  list: async (farmId: string): Promise<PondResponse[]> => {
    const response = await apiClient.get<{ data: PondResponse[] }>(`/farms/${farmId}/ponds`)
    return response.data.data
  },

  get: async (farmId: string, pondId: string): Promise<PondResponse> => {
    const response = await apiClient.get<{ data: PondResponse }>(`/farms/${farmId}/ponds/${pondId}`)
    return response.data.data
  },

  create: async (farmId: string, data: PondCreateRequest): Promise<PondResponse> => {
    const response = await apiClient.post<{ data: PondResponse }>(`/farms/${farmId}/ponds`, data)
    return response.data.data
  },

  update: async (farmId: string, pondId: string, data: PondUpdateRequest): Promise<PondResponse> => {
    const response = await apiClient.put<{ data: PondResponse }>(`/farms/${farmId}/ponds/${pondId}`, data)
    return response.data.data
  },

  delete: async (farmId: string, pondId: string): Promise<void> => {
    await apiClient.delete(`/farms/${farmId}/ponds/${pondId}`)
  },
}
